import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import TrimSelector from '../../../2_Molecules/TrimSelector/TrimSelector';
import { convertCurrency } from '../../../../utils/helpers';
import { handleRequest } from '../../../../utils/httpRequest';
import generalController from '../../../../controllers/generalController';
import { getApiBaseUrl } from '../../../../utils/endPoints';

function TrimSelectorsCarousel({
  modelData,
  trimsOrder,
  trimsOptions,
  activeSlide,
  setTrimsOrder,
  setActiveSlide,
}) {
  // TODO: Remove this line when the specs API response includes the price info.
  const [tempPriceInfo, setTempPriceInfo] = useState({});

  const updateTrimsOrder = (index, value) => {
    const newOrder = [...trimsOrder];
    newOrder[index] = value;
    setTrimsOrder(newOrder);
  }

  // TODO: Remove this whole useEffect when the specs API response includes the price info.
  useEffect(() => {
    const getPriceByModel = async () => {
      const prices = {};
      const province = generalController.getMetatagValue('province');
      const language = generalController.detectLanguage();

      for (const trimName of trimsOrder) {
        const trimData = modelData[trimName];
        const { model_code, option_code } = trimData;
        const url = `${getApiBaseUrl()}/api/Financial/${model_code}/${option_code}?prov_code=${province}&lang_code=${language}`;
        const data = await handleRequest('get', url);

        if (data.data && data.data.msrp) {
          prices[trimName] = convertCurrency(data.data.msrp, language)
        }
      }
      
      setTempPriceInfo(prices);
      window.dispatchEvent(new Event('resize'));
    }

    if (modelData && trimsOrder) {
      getPriceByModel();
    }
  }, [])

  return (
    <thead className="mz-table-head">
      <tr>
        {/* Items */}
          {
            trimsOrder.map((trimName, index) => {
              const trimData = modelData[trimName];
              const { trim, model_year, year, carline } = trimData;
              if(tempPriceInfo[trimName] !== undefined){
                return (<TrimSelector
                    key={index}
                    index={index}
                    modelYearData={trim.visual}
                    yearData={year}
                    modelName={carline?.url_slug}
                    defaultTrim={trim?.trim_type.url_slug}
                    trim={trim.trim_type.name}
                    trimOptions={trimsOptions}
                    trimPrice={tempPriceInfo[trimName]}
                    updateTrimsOrder={updateTrimsOrder}
                  />
                )
              }
            })
          }
      </tr>
    </thead>
  )
}

TrimSelectorsCarousel.propTypes = {
  modelData: PropTypes.object.isRequired,
  trimsOrder: PropTypes.array.isRequired,
  trimsOptions: PropTypes.array.isRequired,
  activeSlide: PropTypes.number.isRequired,
  setTrimsOrder: PropTypes.func.isRequired,
  setActiveSlide: PropTypes.func.isRequired,
}

TrimSelectorsCarousel.defaultProps = {
  modelData: {},
  trimsOrder: [],
  trimsOptions: [],
  activeSlide: 0,
}

export default TrimSelectorsCarousel